import React, { useContext, useState } from "react";
import UpDownRow from "./upDownRow";
import DurationRow from "./durationRow";
import { TicketProps } from "../../FlightPackage/Ticket/FlightLegs/ticketFlightLegs";
import { UpDownTimeOnEachLeg } from "../../sharedCode/TimeCalculator";
import { DefinitelyAnArray, sortFlightLegsManually } from "../../sharedCode/HelperMethods";
import { ExtendTicketLocation, TicketLocationExtended } from "../../Utils/TypeExtensions";
import DeleteConfirmationDialog from "../DeleteConfirmationDialog";
import { GlobalContext } from "../../Utils/Contexts";
import { saveTicketChanges } from "../../Utils/TicketDatabase";

interface State {
    ShowDeleteConfirmation: boolean;
    IdToDelete: number;
}

export default function DetailRows(props: TicketProps): JSX.Element {
    const context = useContext(GlobalContext);

    const [localState, setLocalState] = useState<State>({
        ShowDeleteConfirmation: false,
        IdToDelete: 0,
    });

    const upDownRequired = UpDownTimeOnEachLeg(props.ticket);

    const sortedLocations = upDownRequired
        ? (DefinitelyAnArray(props.ticket.Locations).map((l) => ExtendTicketLocation(props.ticket, l)) as TicketLocationExtended[])
        : (DefinitelyAnArray(props.ticket.Locations).map((l) => ExtendTicketLocation(props.ticket, l)) as TicketLocationExtended[]).slice().sort(sortFlightLegsManually);

    return (
        <>
            {localState.ShowDeleteConfirmation && <DeleteConfirmationDialog entityName={"FLIGHT LEG"} onClose={handleDeleteCanceled} onConfirm={handleDeleteConfirmed} />}
            {sortedLocations.map((l) =>
                upDownRequired ? (
                    <UpDownRow {...props} id={l.id} handleDelete={handleDelete} mergeRowChanges={mergeRowChanges} key={`r${l.id}-${sortedLocations.length}`} />
                ) : (
                    <DurationRow
                        {...props}
                        id={l.id}
                        handleDelete={handleDelete}
                        mergeRowChanges={mergeRowChanges}
                        sortedLocations={sortedLocations}
                        key={`r${l.id}-${sortedLocations.length}`}
                    />
                )
            )}
        </>
    );

    function handleDelete(idToDelete: number): void {
        setLocalState((prev) => {
            return { ...prev, ShowDeleteConfirmation: true, IdToDelete: idToDelete };
        });
    }

    function handleDeleteCanceled(): void {
        setLocalState((prev) => {
            return { ...prev, ShowDeleteConfirmation: false, IdToDelete: 0 };
        });
    }

    function handleDeleteConfirmed(): void {
        if (!props.ticket.Locations) return;
        const locationToDelete = props.ticket.Locations.find((p) => p?.id === localState.IdToDelete);
        if (locationToDelete) {
            const indexToDelete = props.ticket.Locations.indexOf(locationToDelete);
            if (indexToDelete > -1) {
                const newList = [...props.ticket.Locations.slice(0, indexToDelete), ...props.ticket.Locations.slice(indexToDelete + 1)];

                newList.forEach((item, index) => {
                    if (item) item.sort_order = index;
                });

                saveTicketChanges(context.selectedTicketId, { Locations: newList }).catch(() => props.showForceReloadDialogue());
            }
        }
    }

    function mergeRowChanges(locationId: number, changes: Record<string, unknown>) {
        const locations = props.ticket?.Locations?.map((location) => {
            if (location?.id === locationId) {
                return { ...location, ...changes } as TicketLocationExtended;
            } else {
                return location;
            }
        });

        saveTicketChanges(props.ticket.id, { Locations: locations }).catch(() => props.showForceReloadDialogue());
    }
}
